// frontend/src/components/charts/tooltipTotal.js
//
// The total line under a chart tooltip's breakdown.

/**
 * The sum of the parts a tooltip lists, or null when there are fewer than two.
 *
 * @param {Array<number|null>} values — one per stacked series; null = no row.
 * @returns {number|null}
 */
export function sumOfParts(values) {
  const parts = values.filter(v => v != null);
  return parts.length < 2 ? null : parts.reduce((sum, v) => sum + v, 0);
}

/**
 * The tooltip footer as HTML, styled by styles/ag-charts.css. AG Charts
 * inserts a renderer's string as raw HTML, so the text goes in through the DOM.
 *
 * @param {Array<{label: string, value: string}>} rows — already formatted.
 * @returns {string} '' when there are no rows, so the tooltip shows no footer.
 */
export function tooltipTotalHtml(rows) {
  if (rows.length === 0) return '';
  const block = document.createElement('div');
  block.className = 'ag-charts-tooltip-content chart-tooltip-total';
  for (const { label, value } of rows) {
    const row = block.appendChild(document.createElement('div'));
    row.className = 'ag-charts-tooltip-row';
    const labelSpan = row.appendChild(document.createElement('span'));
    labelSpan.className = 'ag-charts-tooltip-label';
    labelSpan.textContent = label;
    const valueSpan = row.appendChild(document.createElement('span'));
    valueSpan.className = 'ag-charts-tooltip-value';
    valueSpan.textContent = value;
  }
  return block.outerHTML;
}
